<template>
    <div>
        <span>{{ carrier }}{{ suffix }}</span>
    </div>
</template>

<script>
export default {
  name: 'Mybottom',
  data () {
    return {
      carrier: 0,
      funcNum: null
    }
  },
  props: {
    num: {
      type: Number,
      default: 0
    },
    ms: {
      type: Number,
      default: 10
    },
    s: {
      type: Number,
      default: 2000
    },
    suffix: {
      type: String,
      default: ''
    }
  },
  watch: {
    num: function () {
      this.numChange()
    }
  },
  created () {
  },
  mounted () {
    this.numChange()
  },
  methods: {
    numChange () {
      if (this.ms < Math.abs(this.num)) {
        let add = Math.round(this.num / this.ms)
        let intervalTime = this.s / this.ms
        let _this = this
        this.funcNum = setInterval(() => {
          _this.carrier += add
        }, intervalTime)
        setTimeout(() => {
          clearInterval(_this.funcNum)
          this.carrier = this.num
        }, this.s)
      } else {
        this.carrier = this.num
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/rollNum/rollNum.vue